import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import noop from 'lodash/noop'
import { globalKeyStore } from '../../redux/actions/globalState'
import ConfirmationPage from './ConfirmationPage'
import PaymentBookingPage from './PaymentBookingPage'
import FormCard from './FormCard'
import CommonBtn from '../../components/global/CommonBtn'
import { EMPTY_OBJECT, EVENT_TYPES } from '../../constants/globalConstants'
import MultipleEventCrousel from '../../components/global/MultipleEventCrousel'
import EventCard from '../../components/global/EventCard'
import moment from 'moment'
import {
    getEventDetails,
    getFilteredEventList,
} from '../../redux/actions/MainAction'
// import { useLocation } from 'react-router'
import { getFormattedAmountNumber, getPartnerDetails } from '../../utils/helper'
import { useForm } from 'react-hook-form'
import Loader from '../../components/global/Loader'
import { getSessionDetails } from '../../redux/actions/booking'
import CONSTANTS from '../../redux/constants'
import { useNavigate } from 'react-router'
import { useParams } from 'react-router-dom'
import  getConfigDetails  from '../../services/config'
import Banner from '../../components/global/Banner'

// import BookingAlert from '../../components/global/BookingAlert'

function Booking({ dispatch, bookingFormPage, eventData, loader, selectEventType, notify, selectedFacilityId, selectedYearForLabel, partnerDetails }) {
    const partner = window.location.toString().split('/')[3]
    const navigate = useNavigate()
    const { facility, independant_pass_id, event_id } = useParams()
    const nextFormStep = () => dispatch(globalKeyStore({ bookingFormPage: bookingFormPage + 1 }))

    const prevFormStep = () => dispatch(globalKeyStore({ bookingFormPage: bookingFormPage - 1 }))

    const { register, handleSubmit, watch, formState: { errors }, control, getValues, reset, setValue } = useForm()
    // console.log('eventData',eventData)
    const fname = watch('name', false)
    const femail = watch('email', false)
    const fphone = watch('phone', false)
    const expiration_date = watch('expiration_date', false)
    const fcard_pan = watch('card_pan', false)
    const fcard_date_expiry_year = watch('card_date_expiry_year', false)
    const fcard_date_expiry_month = watch('card_date_expiry_month', false)
    const fcard_card_security_cvx_2 = watch('card_card_security_cvx_2', false)
    // const { pathname } = useLocation()
    const [sessionObj, setSessionObj] = useState(null)
    const localFacilityId = facility ? facility : JSON.parse(localStorage.getItem('selectedFacilityId'))
    const partnerData = getPartnerDetails()
    const [facilityDet, setFacilityDet] = useState({
        name: null,
        defaultPrice: getFormattedAmountNumber('0.00')
    })
    
    // EOS-973
    const tokenRef = useRef(null)
    const [cardToken, setCardToken] = useState('')
    const [iframeErrorMsg, setIframeErrorMsg] = useState('')
    // EOS-973

    useEffect(() => {
        if (getPartnerDetails()?.clients?.secret) {
            const end_time_local = localStorage.getItem('end_time')
            const today = end_time_local ? moment(end_time_local, 'YYYY-MM-DD HH:mm:ss')?.format('YYYY-MM-DD') : selectedYearForLabel ? moment(selectedYearForLabel, 'YYYY/MM/DD')?.format('YYYY-MM-DD') : moment()?.format('YYYY-MM-DD')
            const end_date = moment(today, 'YYYY-MM-DD').endOf('month').format('YYYY-MM-DD')
            const pathId = event_id ? event_id : localStorage.getItem('booking_event')

            let partOrRM = partnerData?.partner_details ? partnerData?.slug : partnerData?.partner_slug
            if (!independant_pass_id && (!pathId || (partnerData && (partner?.toLowerCase() !== (partOrRM || '')?.toLowerCase())))) {
                if (facility && event_id) {
                    navigate(`/${partner}/event/${facility}/${event_id}`)
                } else {
                    navigate('/' + partner)
                }
            }
            dispatch({ type: CONSTANTS.SESSION_EVENT_REQUEST })
            // to filter the date of current month from api:-
            // const currentSelDate = end_time_local ? moment(end_time_local)?.format('MMM-YYYY') : moment(startDate)?.format('MMM-YYYY')

            // to find the id from url 
            // const curUrlPath = pathname?.split('/') // Old functionality
            // const pathId = curUrlPath[curUrlPath.length - 1] // Old functionality
            // facility id 

            const selLocalFacilityId = facility ? facility : JSON.parse(localStorage?.getItem('selectedFacilityId'))

            if (selLocalFacilityId || selectedFacilityId) {
                const eventFacilityid = (selLocalFacilityId) ? selLocalFacilityId : selectedFacilityId
                dispatch(globalKeyStore({ selectedFacilityId: eventFacilityid }))

                const sessionPayload = {
                    'is_first_load': 1,
                    'facility_id': eventFacilityid,
                    'rate_id': '',
                    'event_id': '',
                    'client_id': getConfigDetails?.CLIENT_SECRET
                }
                // getting Selected Event type from local 
                const localSelectedType = (facility && event_id) ? 'event' : localStorage?.getItem('selectEventType')
                dispatch(globalKeyStore({ selectEventType: localSelectedType }))

                // conditional for event / pass
                if (localSelectedType !== 'event' || independant_pass_id) {
                    sessionPayload.rate_id = independant_pass_id ? Number(independant_pass_id) : (localSelectedType !== 'event') ? Number(pathId) : ''
                    dispatch(globalKeyStore({ selectedPassId: Number(pathId) }))
                    const passtype = localStorage.getItem('pass_type_slug')
                    const eventpayload = {
                        event_type: passtype ? passtype : EVENT_TYPES?.BUNDLE_PASS,
                        facility_id: eventFacilityid,
                        pass_id: independant_pass_id ? independant_pass_id : pathId,
                        start_date: today,
                        end_date: end_date
                    }
                    dispatch(globalKeyStore({ startValue: new Date(today) }))
                    if (eventpayload?.facility_id !== null) {
                        dispatch(getFilteredEventList(eventpayload)).then((res) => {
                            dispatch(globalKeyStore({ selectedPassId: Number(pathId), passData: res?.data, selectEventType: 'pass' }))
                        })
                    } else {
                        // navigate(0)
                    }

                    localStorage.setItem('bookingFormPage', bookingFormPage)
                } else {
                    sessionPayload.event_id = Number(pathId)

                    dispatch(globalKeyStore({ selectedEventId: Number(pathId) }))
                    // api for event
                    const eventpayload = {
                        event_id: pathId,
                        facility_id: eventFacilityid
                    }
                    dispatch(globalKeyStore({ startValue: new Date(today) }))
                    dispatch(getEventDetails(eventpayload)).then((res) => {
                        if(res?.data) {
                            const filterData = [res?.data]
                            localStorage.setItem('eventData', JSON.stringify(filterData))
                            if (pathId !== 0 && pathId !== undefined && pathId !== null) {
                                dispatch(globalKeyStore({ bookingFormPage: 0, eventData: filterData, selectedEventId: Number(pathId) }))
                            }
                        } else {
                            localStorage.removeItem('eventData')
                            dispatch(globalKeyStore({ bookingFormPage: 0, eventData: res?.errors, selectedEventId: Number(pathId)}))
                        }
                    })
                }
                localStorage.setItem('bookingFormPage', bookingFormPage)
                setSessionObj(sessionPayload)
                dispatch(getSessionDetails(sessionPayload)).then((res) => {
                    // if(facility && event_id && res?.errors) {
                    //     navigate('/' + partner)
                    // }
                    // if(!isNaN(pathId) && pathId) {
                    //     dispatch({ type: CONSTANTS.SESSION_EVENT_COMPLETE })
                    //     dispatch(globalKeyStore({ 'sessionDetails': res }))
                    // } else if(event_id && facility) {
                    //     dispatch({ type: CONSTANTS.SESSION_EVENT_COMPLETE })
                    //     dispatch(globalKeyStore({ 'sessionDetails': { errors: 'No events available.' } }))
                    // } else if(facility && independant_pass_id && isNaN(independant_pass_id)) {
                    //     dispatch({ type: CONSTANTS.SESSION_EVENT_COMPLETE })
                    //     dispatch(globalKeyStore({ 'sessionDetails': { errors: 'No passes available.' } }))
                    // } else {
                    //     dispatch({ type: CONSTANTS.SESSION_EVENT_COMPLETE })
                    //     dispatch(globalKeyStore({ 'sessionDetails': res }))
                    // }
                    // console.log(isNaN(event_id), event_id, 'I am here')
                    if((isNaN(event_id) && event_id) || isNaN(facility) || (facility && independant_pass_id && isNaN(independant_pass_id)) || res?.errors) {
                        navigate('/' + partner)
                        // dispatch({ type: CONSTANTS.SESSION_EVENT_COMPLETE })
                        // dispatch(globalKeyStore({ 'sessionDetails': { errors: { message: 'Error Block.' } } }))
                    } else {
                        dispatch({ type: CONSTANTS.SESSION_EVENT_COMPLETE })
                        dispatch(globalKeyStore({ 'sessionDetails': res }))
                    }
                }).catch((err) => {
                    dispatch({ type: CONSTANTS.SESSION_EVENT_COMPLETE })
                    console.log(err)
                })
            }
            localStorage.setItem('coupon', '')
            localStorage.setItem('couponApplied', '')
            localStorage.setItem('couponFilled', '')
            localStorage.setItem('promo_applied', '')
            if (eventData?.length > 0 && eventData[0]?.facilities?.length) {
                let facilityName = eventData[0].facilities.filter((item) => item.id === localFacilityId)
                if (facilityName.length > 0) {
                    setFacilityDet({ ...facilityDet, defaultPrice: facilityName[0].base_event_rate, name: facilityName[0].full_name })
                }
            }
        }
        if(event_id) {
            localStorage?.setItem('selectEventType', 'event')
        }

    }, [getPartnerDetails()?.clients?.secret])

    const backToDetail = () => {
        navigate(-1)
    }

    return (
        (loader) ? <div className='d-flex align-content-center flex-wrap vh-100 justify-content-center'><Loader /></div> : <>
            {selectEventType == 'event' && eventData?.message ? <>
                <Banner partnerDetails={partnerDetails} />
                <h4 className='w-100 text-primary py-3 text-center mt-3'>{eventData?.message}</h4>
            </> :
            <div className="container my-5">
                <div className="position-relative m-4 mb-5">
                    <div className="progress" role="progressbar" aria-label="Progress" aria-valuenow="50" aria-valuemin="0" aria-valuemax="100" style={{ height: '1px' }}>
                        <div className="progress-bar" style={bookingFormPage === 1 ? { width: '50%' } : { width: '0%' }}></div>
                    </div>
                    <CommonBtn isProgressBtn className={'position-absolute top-0 start-0 translate-middle btn btn-sm btn-primary rounded-pill'} value={'1'} style={{ width: '2rem', height: '2rem' }} />
                    <CommonBtn isProgressBtn className={bookingFormPage == 1 || bookingFormPage == 2 ? 'position-absolute top-0 start-50 translate-middle btn btn-sm btn-primary rounded-pill' : 'position-absolute top-0 start-50 translate-middle btn btn-sm btn-secondary rounded-pill'} value={'2'} style={{ width: '2rem', height: '2rem' }} />
                    <CommonBtn isProgressBtn className={bookingFormPage == 2 ? 'position-absolute top-0 start-100 translate-middle btn btn-sm btn-success rounded-pill' : 'position-absolute top-0 start-100 translate-middle btn btn-sm btn-secondary rounded-pill'} value={'3'} style={{ width: '2rem', height: '2rem' }} />
                </div>
                <div className='mb-3 d-flex justify-content-end'>
                    <button type="button" onClick={backToDetail} className="btn btn-secondary"><i className="fa fa-chevron-circle-left"></i> Back</button>
                </div>

                    <section>
                        {selectEventType == 'event' ? <>
                                <EventCard
                                    key={eventData?.[0]?.id}
                                    eventIndex={eventData?.[0]?.id}
                                    allFacility={eventData?.[0]?.facilities}
                                    imageUrl={(eventData?.[0]?.image_url) ? eventData?.[0]?.image_url : 'NoImage'}
                                    title={eventData?.[0]?.title}
                                    detials={eventData?.[0]?.description}
                                    startDate={eventData?.[0]?.start_time}
                                    time={eventData?.[0]}
                                    paybaleAmount={eventData?.[0]?.paybaleAmount}
                                    id={eventData?.[0]?.id}
                                    parkingPrice={selectEventType == 'event' ? (Number(eventData?.[0]?.event_rate) == 0 || Number(eventData?.[0]?.event_rate) == 0) ? eventData?.[0]?.facilities?.[0]?.base_event_rate : eventData?.[0]?.event_rate : eventData?.[0]?.price}
                                    isPriceDetialshowInEvent
                                    facilitiesName={facilityDet.name ? facilityDet.name : eventData?.[0]?.facilities?.[0]?.full_name}
                                    facilityPrice={facilityDet.defaultPrice}
                                    page='details'
                                    isMultiplefacility={eventData?.[0]?.event_facility && eventData?.[0]?.event_facility?.length > 1}
                                />
                            </> : <MultipleEventCrousel
                                hidePaymentDetails
                                page='details'
                            />}
                    </section>

            <div>
                <FormCard currentStep={bookingFormPage} prevFormStep={prevFormStep}>
                    {bookingFormPage >= 0 && (<div className={bookingFormPage === 0 ? 'd-block border p-2' : 'd-none'}><PaymentBookingPage
                        notify={notify}
                        reset={reset}
                        register={register}
                        handleSubmit={handleSubmit}
                        control={control}
                        errors={errors}
                        bookingFormPage={bookingFormPage}
                        nextFormStep={nextFormStep}
                        getValues={getValues}
                        sessionObj={sessionObj}
                        setValue={setValue}
                        fname={fname}
                        femail={femail}
                        fphone={fphone}
                        fcard_pan={fcard_pan}
                        fcard_date_expiry_year={fcard_date_expiry_year}
                        fcard_date_expiry_month={fcard_date_expiry_month}
                        fcard_card_security_cvx_2={fcard_card_security_cvx_2}
                        expiration_date={expiration_date}
                        tokenRef={tokenRef}
                        cardToken={cardToken}
                        setCardToken={setCardToken}
                        iframeErrorMsg={iframeErrorMsg}
                        setIframeErrorMsg={setIframeErrorMsg}
                    /></div>)}

                    {bookingFormPage >= 1 && (<div className={bookingFormPage === 1 ? 'd-block' : 'd-none'}>
                        <ConfirmationPage 
                            allFacility={eventData?.[0]?.facilities} 
                            bookingFormPage={bookingFormPage} 
                            nextFormStep={nextFormStep} 
                            prevFormStep={prevFormStep} 
                            paybaleAmount={eventData?.[0]?.paybaleAmount} 
                            notify={notify} 
                            tokenRef={tokenRef}
                            cardToken={cardToken}
                            setCardToken={setCardToken}
                            iframeErrorMsg={iframeErrorMsg}
                            setIframeErrorMsg={setIframeErrorMsg}
                        /></div>)}
                </FormCard>
            </div>
        </div>}
    </>
    )
}

Booking.propTypes = {
    dispatch: PropTypes.func,
    notify: PropTypes.func,
    selectedEventId: PropTypes.number,
    bookingFormPage: PropTypes.number,
    eventData: PropTypes.object,
    startDate: PropTypes.string,
    loader: PropTypes.bool,
    selectEventType: PropTypes.string,
    sessionDetails: PropTypes.object,
    selectedFacilityId: PropTypes.string,
    selectedYearForLabel: PropTypes.string,
    partnerDetails: PropTypes.object,
}

Booking.defaulProps = {
    dispatch: noop,
    notify: noop,
    selectedEventId: 1,
    bookingFormPage: 0,
    eventData: EMPTY_OBJECT,
    startDate: new Date(),
    loader: false,
    selectEventType: '',
    sessionDetails: EMPTY_OBJECT,
    selectedFacilityId: '',
    selectedYearForLabel: '',
    partnerDetails: EMPTY_OBJECT,
}



function mapStateToProps({ globalReducers, mainReducer }) {
    return {
        selectedPassType: globalReducers?.selectedPassType,
        selectedEventId: globalReducers?.selectedEventId,
        bookingFormPage: globalReducers?.bookingFormPage,
        eventData: globalReducers?.eventData,
        startDate: globalReducers?.startValue,
        loader: mainReducer?.loader,
        selectEventType: globalReducers?.selectEventType,
        sessionDetails: globalReducers?.sessionDetails,
        selectedFacilityId: globalReducers?.selectedFacilityId,
        selectedYearForLabel: globalReducers?.selectedYearForLabel,
        partnerDetails: globalReducers?.partnerDetails,
    }
}

export default connect(mapStateToProps)(Booking)